import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { ShareEvent, ShareLink, SharedVideoData, SharedVideoWhosGet } from '@/types/share';

// ========== HELPER FUNCTIONS ==========

export function getStoredUser() {
  const loginChecked = localStorage.getItem("checkedLogin");
  const raw = loginChecked
    ? localStorage.getItem("user")
    : sessionStorage.getItem("user");
  return raw ? JSON.parse(raw) : null;
}

export function getChartDataByDay(events: ShareEvent[], days = 14) {
  const now = new Date();
  const data = [];
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    const dateStr = date.toISOString().split("T")[0];
    const dayEvents = events.filter(
      (e) => e.createdAt && e.createdAt.startsWith(dateStr),
    );
    data.push({
      date: date.toLocaleDateString(getInterfaceLanguage(), {
        day: "2-digit",
        month: "short",
      }),
      copies: dayEvents.length,
    });
  }
  return data;
}

export function getTopCountries(events: ShareEvent[], limit = 5) {
  const countryMap = new Map();
  events.forEach((e) => {
    const country = e.geo?.country || "Desconhecido";
    countryMap.set(country, (countryMap.get(country) || 0) + 1);
  });
  return Array.from(countryMap.entries())
    .map(([country, copies]) => ({ country, copies }))
    .sort((a, b) => b.copies - a.copies)
    .slice(0, limit);
}

export function getTopStates(events: ShareEvent[], limit = 5) {
  const stateMap = new Map();
  events.forEach((e) => {
    const state = e.geo?.region || "Desconhecido";
    stateMap.set(state, (stateMap.get(state) || 0) + 1);
  });
  return Array.from(stateMap.entries())
    .map(([state, copies]) => ({ state, copies }))
    .sort((a, b) => b.copies - a.copies)
    .slice(0, limit);
}

// ========== ADAPTERS ==========

export function backendToShareLink(record: SharedVideoData): ShareLink {
  return {
    id: record.id_shared_video || record._id,
    videoId: record.id_video,
    ownerUserId: record.id_user,
    code: record.hash,
    status: record.active ? "active" : "revoked",
    createdAt: record.createdAt,
    expiresAt: null,
    maxCopies: null,
    copiesCount: record.whos_get ? record.whos_get.length : 0,
    link: record.link,
    qrCode: record.qr_code,
    settings: {},
  };
}

export function whosGetToEvents(whosGetArray: SharedVideoWhosGet[], record: SharedVideoData): ShareEvent[] {
  if (!whosGetArray || !Array.isArray(whosGetArray)) return [];
  return whosGetArray.map((entry, i) => ({
    id: `${record.id_shared_video || record._id}_ev_${i}`,
    shareLinkId: record.id_shared_video || record._id,
    videoId: record.id_video,
    ownerUserId: record.id_user,
    recipientUserId: null,
    recipientEmail: entry.email || "",
    createdAt: record.createdAt,
    status: "success",
    method: "link",
    geo: {
      country: entry.country || "",
      region: entry.state || entry.region || "",
      city: entry.city || "",
    },
    errorCode: null,
  }));
}

export function trackShareEvent(event: string, data: any) {
  console.log(`[Analytics] ${event}`, data);
}
